import React from "react";
import { AppFrame } from "../v32/components/frame/AppFrame";

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return <AppFrame>{children}</AppFrame>;
}
